import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

interface QueryResult {
  error: unknown;
  errorUpdatedAt: number;
}

const isHttpError = (error: unknown): boolean => axios.isAxiosError(error) && (error.response?.status ?? 0) >= 400;

export function useOpenSearchFallback({ error, errorUpdatedAt }: QueryResult) {
  const navigate = useNavigate();

  useEffect(() => {
    if (errorUpdatedAt === 0 || !isHttpError(error)) return;
    navigate('?source=ddb', { replace: true });
    // errorUpdatedAt is the discriminant — fires once per new final RQ error
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorUpdatedAt]);
}
